export * from './moduleNames';
import { CycleUtils } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
const recurringYearlyCycle = yearCount => ({
  cycleType: PurchaseOffering.CycleType.RECURRING,
  cycleDuration: {
    unit: PurchaseOffering.DurationUnit.YEAR,
    count: yearCount
  }
});
export const YEARLY_PURCHASE_CYCLE = recurringYearlyCycle(1);
export const TWO_YEAR_PURCHASE_CYCLE = recurringYearlyCycle(2);
export const YEARLY_CYCLE_ID = CycleUtils.convertCycleToCycleId(YEARLY_PURCHASE_CYCLE);
export const TWO_YEAR_CYCLE_ID = CycleUtils.convertCycleToCycleId(TWO_YEAR_PURCHASE_CYCLE);
export const DEFAULT_PURCHASE_CYCLE = {
  cycleType: PurchaseOffering.CycleType.RECURRING,
  cycleDuration: {
    unit: PurchaseOffering.DurationUnit.YEAR,
    count: 1
  }
};
export const DEFAULT_SALE_PURCHASE_CYCLE = {
  cycleType: PurchaseOffering.CycleType.RECURRING,
  cycleDuration: {
    unit: PurchaseOffering.DurationUnit.YEAR,
    count: 2
  }
};

// Eclipse color palette - references CSS custom properties defined in styles/colors.scss
// This ensures a single source of truth for colors across TypeScript and SCSS
export const ECLIPSE_BG = 'var(--eclipse-bg-color)';
export const ECLIPSE_PRIMARY_COLOR = 'var(--eclipse-text-color)';
export const ECLIPSE_BLACK_TEXT_COLOR = 'var(--eclipse-black-text-color)';
export const ECLIPSE_SALE_BG_COLOR = 'var(--eclipse-sale-bg-color)';
export const ECLIPSE_SALE_TEXT_COLOR = 'var(--eclipse-sale-text-color)';
export const ECLIPSE_BORDER_COLOR = 'var(--eclipse-border-color)';
export const ECLIPSE_CYCLE_DEFAULT_STROKE = 'var(--eclipse-cycle-default-stroke)';
export const ECLIPSE_SECONDARY_TEXT_COLOR = 'var(--eclipse-secondary-text-color)';
export const ECLIPSE_DISABLED_BORDER_COLOR = 'var(--eclipse-disabled-border-color)';
export const MONTHLY_EXCLUSION_ICON_COLOR = 'var(--eclipse-error-color)';
export const LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_DESKTOP = '#C8C7CC';
export const LEGACY_MONTHLY_EXCLUSION_ICON_COLOR_MOBILE = '#44485F';
export const FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY = 'premium-purchase-plan.cards.feature.free_domain';
export const FREE_DOMAIN_PLAN_CARD_UP_TO_3_YEARS_TRANSLATION_KEY = 'premium-purchase-plan.cards.feature.free_domain_up_to_3_years';
export const FREE_DOMAIN_CHECKOUT_SUMMARY_ONE_YEAR_KEY = 'premium-purchase-plan.checkout_summary.free_domain_for_1_year';
export const FREE_DOMAIN_CHECKOUT_SUMMARY_FIRST_YEAR_KEY = 'premium-purchase-plan.checkout_summary.free_domain_first_year';
export const SAVINGS_ON_CYCLE_KEY = 'premium-purchase-plan.checkout_summary.savings_on_cycle';
export const SAVINGS_ON_CYCLE_TOOLTIP_KEY = 'premium-purchase-plan.checkout_summary.savings_on_cycle_tooltip';
export const MOBILE_STICKY_BUTTON_SPEC = 'mobileStickyButtonV2';
export const MOBILE_STICKY_PLAN_AND_CYCLE_SPEC = 'mobileStickyDesignWithPlanAndCycle';
export const COUNTRY_US = 'US';
export const QUICK_PAY_LIGHTBOX_SPEC = 'quickLightboxPremium';
export const QUICK_PAY_MARKETING_SPEC = 'quickLightboxNewDesign';
export const AI_ANALYZING_TRANSLATION_KEY = 'premium-purchase-plan.eclipse.ai-recommendation.analyzing';
export const AI_RECOMMENDED_FOR_SITE_TRANSLATION_KEY = 'premium-purchase-plan.eclipse.ai-recommendation.title-for-site';
export const AI_RECOMMENDED_FOR_NAME_TRANSLATION_KEY = 'premium-purchase-plan.eclipse.ai-recommendation.title-for-name';
//# sourceMappingURL=consts.js.map